import { render, staticRenderFns } from "./eventSection.vue?vue&type=template&id=5258bee6&scoped=true&"
import script from "./eventSection.vue?vue&type=script&lang=js&"
export * from "./eventSection.vue?vue&type=script&lang=js&"
import style0 from "./eventSection.vue?vue&type=style&index=0&id=5258bee6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5258bee6",
  null
  
)

export default component.exports